import { render } from "./AppointmentSchedule.vue?vue&type=template&id=0c8b9d9e&ts=true"
import script from "./AppointmentSchedule.vue?vue&type=script&lang=ts"
export * from "./AppointmentSchedule.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__